import { BetQLSportItem } from "./";
import { DEFAULT_TREND_TYPES } from "./configs";

const NHLConfig: BetQLSportItem = {
  id: "84d50719-a5b7-4963-891d-8ec4e057b72e",
  name: "NHL",
  url: "nhl",
  tabName: "NHL",
  icon: "hockey-puck",
  imagePath: "NHL",
  key: "NHL",
  lookupKey: "nhl",
  favoriteLine: "moneyline",
  hasTeamPowerProjectionGrades: true,
  hasFGspreadPowerRating: true,
  hasFGmoneylinePowerRating: true,
  hasFGtotalPowerRating: true,
  has1HspreadPowerRating: false,
  has1HmoneylinePowerRating: false,
  has1HtotalPowerRating: false,
  has1PspreadPowerRating: true,
  has1PmoneylinePowerRating: true,
  has1PtotalPowerRating: true,
  hasPitchers: false,
  hasGoals: false,
  hasInjuries: true,
  hasNews: false,
  hasLineup: false,
  hasSchedule: true,
  hasConfiguredSchedule: false,
  hasTeamSummary: false,
  hasGameFilters: true,
  hasStadium: true,
  hasLocation: true,
  hasTeamRecord: true,
  hasApRank: false,
  hasConferenceDropdown: false,
  hasNewsInjuriesColumn: false,
  hasDraws: false,
  hasSharpData: true,
  hasTopTrendsData: true,
  hasPlayerProps: false,
  hasRecommendedBets: true,
  hasPopularEvents: true,
  isCollege: false,
  defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,4,9,5,14]}',
  defaultColumnOrder: [2, 4, 9, 5, 14],
  publicThreshold: 70,
  sharpPercentThreshold: 30,
  sharpCountThreshold: 300,
  publicCountThreshold: 300,
  trendTypes: DEFAULT_TREND_TYPES,
  filters: [
    {
      name: "Moneyline",
      key: "moneyline",
      url: "moneyline-odds",
    },
    {
      name: "Total",
      key: "total",
      url: "totals-spread",
    },
    {
      name: "Spread",
      key: "spread",
      url: "ats-odds",
    },
    {
      name: "1st Period Moneyline",
      key: "1Pmoneyline",
      url: "first-period-moneyline",
    },
    {
      name: "1st Period Total",
      key: "1Ptotal",
      url: "first-period-totals-spread",
    },
    {
      name: "1st Period Spread",
      key: "1Pspread",
      url: "first-period-ats-odds",
    },
    {
      name: "2nd Period Moneyline",
      key: "2Pmoneyline",
      url: "second-period-moneyline",
    },
    {
      name: "2nd Period Spread",
      key: "2Pspread",
      url: "second-period-ats-odds",
    },
    {
      name: "3rd Period Moneyline",
      key: "3Pmoneyline",
      url: "third-period-moneyline",
    },
    {
      name: "3rd Period Spread",
      key: "3Pspread",
      url: "third-period-ats-odds",
    },
  ],
  periods: ["FULLGAME", "FIRSTPERIOD", "SECONDPERIOD", "THIRDPERIOD"],
  periodKeys: ["FG", "1P", "2P", "3P"],
  pickTypes: [
    "moneyline",
    "total",
    "spread",
    "1Pmoneyline",
    "1Pspread",
    "1Ptotal",
    "2Pmoneyline",
    "2Pspread",
    "3Pmoneyline",
    "3Pspread",
  ],
};

export default NHLConfig;
